import { useRef } from "react";
import {
  stickyIssueHeaderClass,
  stickyIssueHeaderWrapClass,
  useStickyIssueStuck,
} from "../../utils/stickyIssueHeader";

export default function StickyIssueHeader({
  active,
  className = "",
  as: Tag = "div",
  children,
  ...props
}) {
  const headerRef = useRef(null);
  const isStuck = useStickyIssueStuck(headerRef, active);

  const classes = [
    className,
    active ? stickyIssueHeaderClass : "",
    active && isStuck ? "is-stuck" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const header = (
    <Tag ref={headerRef} className={classes} {...props}>
      {children}
    </Tag>
  );

  if (!active) return header;

  return (
    <div
      className={[
        stickyIssueHeaderWrapClass,
        isStuck ? "is-stuck" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {header}
    </div>
  );
}
